import { Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { OfferConfirmationComponent } from './components/offer-confirmation/offer-confirmation.component';
import { OfferDeclinedComponent } from './components/offer-declined/offer-declined.component';
import { OfferNotAvailableComponent } from './components/offer-not-available/offer-not-available.component';
import { OfferStatusComponent } from './components/offer-status/offer-status.component';
import { OfferTokenValidationComponent } from './components/offer-token-validation/offer-token-validation.component';
import { OfferFormEmailComponent } from './components/offer-form-email/offer-form-email.component';
import { SiteTermsAndConditionsComponent } from './components/site-terms-and-conditions/site-terms-and-conditions.component';
import { UnsubscribeFromEmailsComponent } from './components/unsubscribe-from-emails/unsubscribe-from-emails.component';
import { SitePrivacyPolicyComponent } from './components/site-privacy-policy/site-privacy-policy.component';

export const routes: Routes = [
    { 'path': '', component:HomeComponent},
    { 'path': 'offer/:alias_id/:prop_id', component:HomeComponent},
    { 'path': 'offerStatus/:alias_id/:prop_id', component:OfferStatusComponent},
    { 'path': 'offerConfirmation/:alias_id/:prop_id', component: OfferConfirmationComponent},
    { 'path': 'offerTokenValidation/:alias_id/:prop_id', component: OfferTokenValidationComponent},        
    { 'path': 'offerDeclined', component: OfferDeclinedComponent},
    { 'path': 'offerGuestEmail/:alias_id/:prop_id', component: OfferFormEmailComponent},   
    { 'path': 'offerNotAvailable', component: OfferNotAvailableComponent},
    { 'path': 'termsOfService', component: SiteTermsAndConditionsComponent},
    { 'path': 'privacyPolicy', component: SitePrivacyPolicyComponent},    

    { 'path': 'unsubscribe/:alias_id/:prop_id/:tenant_id/:email', component: UnsubscribeFromEmailsComponent},

    { 'path': '**',
        component: OfferNotAvailableComponent
    }

];
